<template>
  <el-dialog
      id="createAddBlackListDialog"
      :title="$t('text.blackListCreate')"
      :visible="isShowAddBlackListDialog"
      width="600px"
      @open="openDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
  >
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        v-show="submitted === false"
    >
      <el-form-item
          :label="$t('text.walletOrCardNumber')"
          prop="customerCert"
      >
        <el-input
            v-model="form.customerCert"
            auto-complete="off"
            :placeholder="$t('message.inputWalletOrCardNumber')"
        />
      </el-form-item>


      <el-form-item
          :label="$t('text.channelType')"
          prop="payType"
      >
        <el-select
            v-model="form.payType"
            filterable
            :placeholder="$t('message.chooseOne')"
        >
          <el-option :label="$t('option.all')" value="0"></el-option>
          <el-option :label="$t('text.collection')" :value="PAYMENT_TYPE_ID_COLLECTION()"/>
          <el-option :label="$t('text.disbursement')" :value="PAYMENT_TYPE_ID_PAYMENT()"/>
        </el-select>
      </el-form-item>


      <el-form-item
          :label="$t('text.blackListLockoutDay')"
          prop="blackListLockoutDay"
      >
        <el-select
            v-model="form.blackListLockoutDay"
            filterable
            clearable
            allow-create
            :placeholder="$t('message.inputDays')"
        >
          <el-option :label="$t('text.1week')" value=7></el-option>
          <el-option :label="$t('text.2weeks')" value=14></el-option>
          <el-option :label="$t('text.1month')" value=30></el-option>
          <el-option :label="$t('text.3months')" value=90></el-option>
        </el-select>
      </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="submitted === false">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="submitted === false">{{
          $t('text.confirm')
        }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {PAYMENT_TYPE_ID_COLLECTION, PAYMENT_TYPE_ID_PAYMENT} from "@/utils/Constant";

export default {
  props: {
    isShowAddBlackListDialog: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      form: {
        customerCert: "",
        payType: "0",
        blackListLockoutDay: "",
      },
      rules: {
        customerCert: [
          {required: true, message: this.$t('message.inputWalletOrCardNumber')},
        ],
      },
      loading: null,
      title: "",
      submitted: false,
      result: {
        success: false,
        message: "",
        link: ""
      }
    };
  },
  methods: {
    PAYMENT_TYPE_ID_PAYMENT() {
      return PAYMENT_TYPE_ID_PAYMENT
    },
    PAYMENT_TYPE_ID_COLLECTION() {
      return PAYMENT_TYPE_ID_COLLECTION
    },
    lockDialog() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t("text.loading"),
        spinner: "el-icon-loading",
        target: "#createTestCollectionOrderDialog .el-dialog"
      });
    },
    unlockDialog() {
      if (this.loading !== null) {
        this.loading.close();
      }
    },
    openDialog() {
      this.title = this.$t('text.testOrder');
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: ""
      };
    },
    closeDialog() {
      this.form.merchantUserId = '';
      this.form.orderId = '';
      this.form.merchantOrderId = '';
      this.$refs.form.resetFields();
      this.$emit("update:isShowAddBlackListDialog", false);
    },
    submit() {
      this.$refs.form.validate((valid) => {
            if (valid) {
              this.lockDialog();
              this.$axios
                  .post("/blacklist/add", this.form)
                  .then((res) => {
                    this.unlockDialog();
                    if (res.code === 200) {
                      this.$bus.$emit("refresh");
                      this.closeDialog();
                      this.$notify({
                        title: `${this.$t('text.success')}`,
                        message: res.msg,
                        type: "success",
                      });
                      return true;
                    } else {
                      this.$notify.error({
                        title: this.$t("text.prompt"),
                        message: res.msg
                      });
                      return false;
                    }
                  })
                  .catch(() => {
                    this.unlockDialog();
                    this.$notify.error({
                      title: this.$t("text.prompt"),
                      message: this.$t("message.sysError")
                    });
                  });
            } else {
              return false;
            }
          }
      );
    },
    validateMerchantFields(rule, value, callback) {
      if (!this.form.orderId && !this.form.merchantOrderId) {
        callback(new Error(this.$t('message.inputOrderIdOrMerchantId')));
      } else {
        callback();
      }
    },
    mounted() {
      this.openDialog();
    }
  }
};
</script>